module.exports = __webpack_public_path__ + "img/gesund-at.5a90b232.svg";